import CryptoJS from "crypto-js";
import axios from "axios";
import store from "@/store/index";
import request from "@/utils/request";
import {
  Session
} from "@/utils/storage";
import {
  HexMD5,
  b64hamcsha1
} from "@/utils/hash";
import {
  setUuid
} from "@/api/uploading";

// 获取域名
export function getDomain() {
  let domain = window.location.hostname.split(".");
  if (domain.length == 5) {
    domain = domain[0];
    Session.set("domain", domain);
  } else if (domain.length == 4 && domain[0] != "match" && domain[0] != "192") {
    domain = domain[0];
    Session.set("domain", domain);
  } else {
    //此处配置比赛域名
    // domain = "tcp111";
    domain = ''
    Session.set("domain", domain);
  }
  return domain;
}

//判断正式还是测试
export function getFormal() {
  let formal = window.location.hostname.split(".")
  if (window.location.hostname.indexOf("match") != -1) {
    formal = 'https://api.match.posedu.com.cn'
  } else {
    formal = 'https://api.mt.posedu.com.cn'
  };
  // formal = 'https://api.match.posedu.com.cn'
  return formal
}

//判断协议
export function getHttp() {
  // return "http://192.168.2.74:8080";
  // let http = window.location.href.indexOf("https");
  // if (http == -1) {
  //   return "http://vuetest.posedu.com.cn";
  // } else {
  return getFormal();
  // }
}

// 获取接口地址
export function getUrl() {
  let url = window.location.protocol + "//" + window.location.host + "/"
  // 左文达接口地址
  // let url = "http://welai.free.idcfengye.com"
  // let url = "http://192.168.2.25:8081"; //文达
  // let url = "http://192.168.2.132:8081"  //洪达
  // let url = "http://192.168.2.120:8081"  //冬鸣

  return url;
}

// 上传文件到又拍云
export function uploadCloud(res) {
  console.log("uploadCloud++++++++++++++++++++++++++++++++" + res)

  let policy = window.btoa(
    JSON.stringify({
      bucket: "wlzj-platform",
      "save-key": "/manage/uploads/{year}{mon}{day}/{random32}{.suffix}", //文件路径
      expiration: Math.floor(new Date().getTime() / 1000) + 86400, //过期时间
      "notify-url": getUrl() + "api/enclosure/notify",
      "ext-param": encodeURI(Math.random + "," + getDomain() + "," + 4)
      // 'content-length': 1073741823,
    })
  );
  let signature = CryptoJS.MD5(
    policy + "&1/Ais8tCJTYYTBtgQ/PqVuihffM="
  ).toString(); //此处文件密钥前要添加&符号，容易出错
  var formdata = new FormData();
  formdata.append("policy", policy);
  formdata.append("signature", signature);
  formdata.append("file", res.file);
  // formdata.append('x-upyun-multi-stage','initiate');
  // formdata.append('x-upyun-multi-length','1073741823')

  return new Promise((resolve, reject) => {
    axios
      .post(res.action, formdata, res.moh)
      .then(res => {
        // sleep(2000)
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}

// 又拍云大文件初始化
export function uploadCloudBig(res) {
  console.log("***************************" + JSON.stringify(res))
  let operator = "zhaoyang";
  let name = res.file.name;
  let pwd = "Lxq0ykCsvZ6q7abFfvzw51QmcxgOxr3B";

  let olddate = new Date().toGMTString();
  console.log('date', new Date())
  console.log('date', olddate)
  let suffix = res.file.name.substring(
    res.file.name.lastIndexOf("."),
    res.file.name.length
  );
  let fileName = Math.round(Math.random() * Math.random() * Math.random() * 10000000000) + "asdfv";
  // let url = `/wlzj-platform/${new Date().getTime()}/${fileName+suffix}`;
  let url = `/wlzj-platform/manage/uploads/${new Date().getFullYear()}${new Date().getMonth() + 1 < 10
    ? "0" + new Date().getMonth() + 1
    : new Date().getMonth() + 1
    }${new Date().getDate() < 10
      ? "0" + new Date().getDate()
      : new Date().getDate()
    }/${fileName + suffix}`;
  let postUrl = "https://v0.api.upyun.com" + url;
  let str = "PUT&" + url + "&" + olddate;
  let signature =
    "UPYUN " +
    operator +
    ":" +
    b64hamcsha1(HexMD5.MD5(pwd).toString(HexMD5.enc.Hex), str);
  let headers = {
    "X-Date": olddate,
    Authorization: signature,
    "Content-Length": "0",
    "X-Upyun-Multi-Stage": "initiate",
    "X-Upyun-Multi-Part-Size": "1048576",
    "X-Upyun-Multi-Length": res.file.size,
    "x-upyun-multi-type": res.file.type
  };
  return new Promise((resolve, reject) => {
    axios
      .put(postUrl, res.moh, {
        headers: headers
      })
      .then(res => {
        console.log("最后res", res);
        //存储uuid信息
        setUuid({
          fileName: name,
          params: JSON.stringify(res)
        });
        // UpyStatus(res)
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}

// 将 File 对象转为 ArrayBuffer
export function fileToBuffer(file) {
  return new Promise((resolve, reject) => {
    const fr = new FileReader();
    fr.onload = e => {
      resolve(e.target.result);
    };
    fr.readAsArrayBuffer(file);
    fr.onerror = () => {
      reject(new Error("转换文件格式发生错误"));
    };
  });
}

//切片上传文件
export async function PostFile(remainSize, fileRes, resID, postContunt) {
  let token = sessionStorage.getItem("token")
  console.log('token', token)
  let nextId = null;
  let uuid = null;
  let name = token + fileRes.file.name;
  if (postContunt) {
    nextId = postContunt.headers["x-upyun-next-part-id"];
    uuid = postContunt.headers["x-upyun-multi-uuid"];
  } else {
    nextId = resID.headers["x-upyun-next-part-id"];
    uuid = resID.headers["x-upyun-multi-uuid"];
  }
  let shardSize = 1048576; //以为初始化分片任务时设置的分片大小为基准
  let shardCount = Math.ceil(fileRes.file.size / shardSize); //总片数
  var i = nextId;
  if (nextId == -1) {
    Session.set(uuid, shardCount);
  } else {
    Session.set(uuid, nextId);
  }
  var packet;
  if (remainSize < shardSize) {
    var start = i * shardSize;
    var end = size;
    packet = fileRes.file.slice(start, end); //将文件进行切片
  } else {
    var start = i * shardSize;
    var end = start + shardSize;
    packet = fileRes.file.slice(start, end); //将文件进行切片
  }
  let signature = null;
  let xDate = null;
  let reqUrl = null;
  let tesTime = new Date().toGMTString();
  if (postContunt) {
    if (
      Date.parse(tesTime) - Date.parse(postContunt.config.headers["X-Date"]) >
      1800000
    ) {
      let operator = "zhaoyang";
      let pwd = "Lxq0ykCsvZ6q7abFfvzw51QmcxgOxr3B";
      let str =
        "PUT&" +
        postContunt.config.url.replace("https://v0.api.upyun.com", "") +
        "&" +
        tesTime;
      signature =
        "UPYUN " +
        operator +
        ":" +
        b64hamcsha1(HexMD5.MD5(pwd).toString(HexMD5.enc.Hex), str);
      xDate = tesTime;
    } else {
      signature = postContunt.config.headers.Authorization;
      xDate = postContunt.config.headers["X-Date"];
    }
    reqUrl = postContunt.config.url;
  } else {
    signature = resID.config.headers.Authorization;
    xDate = resID.config.headers["X-Date"];
    reqUrl = resID.config.url;
  }

  let headers = {
    Authorization: signature,
    "X-Date": xDate,
    "X-Upyun-Multi-Stage": "upload",
    "X-Upyun-Multi-Uuid": uuid,
    "X-Upyun-Part-Id": nextId
    //'Content-Type' :'multipart/form-data'
  };
  return new Promise((resolve, reject) => {
    axios({
      url: reqUrl,
      method: "put",
      data: packet,
      headers: {
        ...headers
      }
    })
      .then(res => {
        setUuid({
          fileName: name,
          params: JSON.stringify(res)
        });
        if (res.headers["x-upyun-next-part-id"] == -1) {
          DoneFile(remainSize, fileRes, res);
          resolve("结束");
        } else {
          PostFile(remainSize, fileRes, res);
        }
      })
      .catch(err => {
        reject(err);
      });
  });
}

//结束切块上传
export function DoneFile(remainSize, fileRes, resID) {
  let headers = {
    "X-Upyun-Multi-Stage": "complete",
    "X-Date": resID.config.headers["X-Date"],
    "X-Upyun-Multi-Uuid": resID.headers["x-upyun-multi-uuid"],
    Authorization: resID.config.headers.Authorization
  };
  console.log('结束aaaaa', resID.config.url)
  return new Promise((resolve, reject) => {
    console.log('resID.config.url', resID.config.url)
    axios({
      url: resID.config.url,
      method: "put",
      headers: {
        ...headers
      }
    })
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}

//测试视频地址是否404
export function isRunUrl(url) {
  return new Promise(function (resolve, reject) {
    // 测试链接连通性, 主要检测404错误
    // 由于AJAX通常无法区分404和跨域问题
    // 所以只能用script 或者 link标签
    // link比script更容易捕获错误

    var dom = document.createElement('link');
    dom.href = url;
    dom.rel = 'stylesheet';
    document.head.appendChild(dom);
    dom.onload = function () {
      document.head.removeChild(dom);
      let videoName = url.split('/')[url.split('/').length - 1].split('.')[0]
      resolve(videoName);
    }
    dom.onerror = reject;
  });
}

//获取分块上传进度
export function UpyStatus(resID) {
  if (resID) {
    let operator = "zhaoyang";
    let pwd = "Lxq0ykCsvZ6q7abFfvzw51QmcxgOxr3B";
    let olddate = new Date().toGMTString();
    let url = resID.config.url.replace("https://v0.api.upyun.com", "");
    let str = "GET&" + url + "&" + olddate;
    let signature =
      "UPYUN " +
      operator +
      ":" +
      b64hamcsha1(HexMD5.MD5(pwd).toString(HexMD5.enc.Hex), str);
    return request({
      url: resID.config.url,
      method: "get",
      headers: {
        Authorization: signature,
        "X-Upyun-Multi-Uuid": resID.headers["x-upyun-multi-uuid"],
        "X-Date": olddate
      }
    });
  } else {
    return false;
  }
}

//sleep
export function sleep(n) {
  var start = new Date().getTime();
  while (true) {
    if (new Date().getTime() - start > n) {
      break;
    }
  }
}

// 从又拍云上删除文件
export function deleteFile(res) {
  return new Promise((resolve, reject) => {
    axios
      .post(getUrl() + "/api/enclosure/delFile", res, {
        headers: {
          "Content-Type": "application/json"
        }
      })
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}

//判断时间在那个赛段
export function isDuringDate(sysDAte, beginDateStr, endDateStr) {
  let Str = beginDateStr.split("至");
  var curDate = sysDAte,
    beginDate = Date.parse(new Date(Str[0] + " " + "00:00:00")),
    endDate = Date.parse(new Date(Str[1] + " " + "00:00:00"));
  if (curDate >= beginDate && curDate <= endDate) {
    return true;
  }
  return false;
}

// 手机号码
export function verifyPhone(val) {
  // false: 手机号码不正确
  if (
    !/^((12[0-9])|(13[0-9])|(14[0-9])|(15([0-9]))|(16[0-9])|(17[0-9])|(18[0-9])|(19[0-9]))\d{8}$/.test(
      val
    )
  )
    return false;
  // true: 手机号码正确
  else return true;
}



// WEBPACK FOOTER //
// ./src/utils/toos.js